import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 border border-foreground-200/60 rounded-full text-xs font-label text-foreground-500 tracking-wide mb-4">
            14 Collections
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-3">
            Every Category.
            <br />
            One Spreadsheet.
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            One-click access to all product categories. Browse sneakers, streetwear, accessories, and more.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center text-center p-4 md:p-5 rounded-lg bg-background-50 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-background-200/70 group-hover:bg-primary-100 transition-colors mb-3">
                <i className={`${cat.icon} text-lg md:text-xl text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
              </span>
              <h3 className="font-label text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-400 mt-1 hidden md:block">
                {cat.description}
              </span>
              <i className="ri-arrow-right-line text-xs text-foreground-300 mt-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}